/**
 * 由 CoCo 源代码计划解包器解包
 *
 * 模块 ID：1605
 */

var r = require(/* 86 */"../1650/86/index")
var o = require(/* 1246 */"../1785/1246/index")
r({
  target: "Array",
  stat: true,
  forced: !require(/* 948 */"./948")(function (e) {
    Array.from(e)
  })
}, {
  from: o
})
